import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, NgZone, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { AccountService } from '../../../providers/account.service';
import { AuthService } from '../../../providers/auth.service';
import { UserService } from '../../../providers/user.service';
import { AccountNaturalFormComponent } from '../../general/account-natural-form/account-natural-form.component';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  dataUser: string;
  dataMobile: string;
  dataPass: string;
  mobile: string;
  changePass = false;
  newdataPass: any;
  retypeDataPass: any;
  otp: boolean;
  otpMobile: string;
  otpValue: any;
  // The OTP is always 4 digits, entered one per box.
  readonly OTP_LENGTH = 4;
  otpDigits: string[] = new Array(this.OTP_LENGTH).fill('');
  @ViewChildren('otpBox') private otpBoxes: QueryList<ElementRef<HTMLInputElement>>;
  debt: number;
  toResendOTP: number;
  enableResendOTP: boolean;
  resendInterval;
  sendPasswordColumns = [
    { name: 'username', label: 'email', type: { name: 'text' }, rules: [{ type: 'required' }] },
    { name: 'mobile', type: { name: 'mobile' }, rules: [{ type: 'required' }] }];

  closeResult: string;

  // --- connecting-dots background -------------------------------------------
  @ViewChild('bgCanvas') private bgCanvas: ElementRef<HTMLCanvasElement>;
  private ctx: CanvasRenderingContext2D;
  private dots: { x: number, y: number, vx: number, vy: number, r: number }[] = [];
  private frameId = 0;
  private pointer = { x: 0, y: 0, active: false };
  private readonly LINK_DISTANCE = 130;
  private readonly RGB = '254, 0, 0';
  private readonly DOT_RADIUS = 4;
  private readonly LINE_WIDTH = 2;
  private readonly SPEED = 6;
  private readonly BASE_DRIFT = 0.45;
  constructor(
    public cookieService: CookieService,
    public translator: TranslateService,
    public auth: AuthService,
    public router: Router,
    public userService: UserService,
    public accountService: AccountService,
    private modalService: NgbModal,
    public titleService: Title,
    private zone: NgZone,
    @Inject(DOCUMENT) private document: Document,
  ) {
    super(auth, translator, cookieService, titleService);

    if (this.token) {
      this.document.dir = this.lang === 'en' ? 'ltr' : 'rtl';
      this.auth.reauthenticate().subscribe(
        (res: any) => {
          this.service.sendMessage(this.token);
          this.router.navigate(['/dashboard']);
        }, (err) => {
          this.clearCookie();
          this.router.navigate(['/']);
        }
      );
    } else {
      this.clearCookie();
    }
  }

  register() {
    this.modalService.open(AccountNaturalFormComponent, { size: 'lg' });
  }

  login() {
    this.document.dir = this.lang === 'en' ? 'ltr' : 'rtl';
    if (this.otp && (!this.otpValue || this.otpValue.length !== this.OTP_LENGTH)) {
      this.handleError(this.translator.instant('MSG_CREDENTIAL_EMPTY'));
      return;
    }
    if (this.dataUser && (this.dataPass || this.otpValue)) {
      this.auth.login(this.dataUser, this.dataPass, this.otpValue).subscribe((res: any) => {

        this.token = res.token;
        this.role = res.role;
        this.ownRole = res.own_role;
        this.internalLine = res.internal_line;
        this.username = res.username;
        this.legacyId = res.legacy_id;
        if (this.role.includes('PERSONNEL')) {
          try {
            this.cookLocation();
          } catch (error) {
            console.error(error)
          }
          this.service.sendMessage(this.token)
        }
        // if (res.change_password === 1) {
        //   this.changePass = true;
        // } else {
        this.router.navigate(['/dashboard']);
        // }

      }, (err) => {
        this.handleError(err);
      }
      );
    } else {
      this.handleError(this.translator.instant('MSG_CREDENTIAL_EMPTY'));
    }
  }

  // sendAccountPassword() {
  //   this.accountService.sendAccountPassword(this.username, this.mobile, this.lang).subscribe(
  //     (result: any) => {
  //       this.handleSuccess();
  //     }, error => {
  //       this.handleError(error);
  //     }
  //   );
  // }

  // changePassword() {
  //   if (this.newdataPass && this.retypeDataPass && this.dataPass) {
  //     if (this.newdataPass === this.retypeDataPass) {
  //       this.accountService.changePassword(this.dataPass, this.newdataPass).subscribe(
  //         (result: any) => {
  //           if (result && result.changedRows) {
  //             this.newdataPass = this.retypeDataPass = this.dataPass = '';
  //             this.handleSuccess();
  //             this.router.navigate(['/dashboard']);
  //           } else if (result) {
  //             this.handleWarning(this.translator.instant('MSG_CURRENT_PASS_WRONG'));
  //           } else {
  //             this.handleError(this.translator.instant('MSG_CHANGE_PASSWORD_FAIL'));
  //           }
  //         }, error => {
  //           this.handleError(error);
  //         }
  //       );
  //     } else {
  //       this.handleError(this.translator.instant('MSG_CHANGE_PASSWORD_NEW_NOT_EQ_CONFIRM'));
  //     }
  //   } else {
  //     this.handleWarning(this.translator.instant('MSG_REVIEW_INPUTS'));
  //   }

  // }

  openForget(content) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${reason}`;
    });
  }

  forgetPass() {

    const username = this.dataUser;
    const mobile = this.dataMobile;

    this.accountService.sendAccountPassword(username, mobile, this.lang).subscribe({
      next: (result: any) => {
        this.handleSuccess();
      }, error: error => {
        this.handleError(this.translator.instant('MSG_SEND_PASSWORD_ERROR'));
      }
    });


  }

  redirectPay() {
    if (this.dataUser) {
      this.router.navigate([`/payall/${this.dataUser}`]);
    }
  }

  openMobile() {
    document.location.href = 'https://app.petiak.com';
  }

  async sendOTP() {
    try {
      if (this.dataUser) {
        const result = await (this.accountService.sendOTP(this.dataUser, this.lang).toPromise());
        this.otp = true;
        this.clearOTP();
        this.otpMobile = (result as any).mobile;
        this.toResendOTP = 120;
        this.enableResendOTP = false;
        if (this.resendInterval) {
          clearInterval(this.resendInterval);
        }
        this.resendInterval = setInterval(() => {
          this.toResendOTP -= 1;
          if (this.toResendOTP == 0) {
            this.enableResendOTP = true;
          }
        }, 1000);
      } else {
        throw new Error('OTP_USERNAME_NULL_ERROR')
      }
    } catch (error) {
      this.handleError(error);
    }
  }

  /* ------------------------------------------------------------- OTP boxes --
   * Four single-digit inputs kept in sync with `otpValue`, the string the login
   * call sends. The boxes are written to directly rather than through ngModel so
   * rejected keystrokes (letters, extra digits) never linger in the DOM.
   */

  onOtpInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '');
    if (!digits) {
      this.otpDigits[index] = '';
      this.syncOTP();
      return;
    }
    // A code pasted or autofilled into one box spreads over the boxes after it.
    this.writeOTPDigits(index, digits);
    this.focusOTPBox(Math.min(index + digits.length, this.OTP_LENGTH - 1));
  }

  onOtpKeydown(event: KeyboardEvent, index: number) {
    switch (event.key) {
      case 'Backspace':
        if (!this.otpDigits[index] && index > 0) {
          // An empty box steps back and clears the one before it.
          event.preventDefault();
          this.otpDigits[index - 1] = '';
          this.syncOTP();
          this.focusOTPBox(index - 1);
        }
        break;
      case 'ArrowLeft':
        event.preventDefault();
        this.focusOTPBox(index - 1);
        break;
      case 'ArrowRight':
        event.preventDefault();
        this.focusOTPBox(index + 1);
        break;
      case 'Enter':
        event.preventDefault();
        this.login();
        break;
    }
  }

  onOtpSelect(event: Event) {
    // The boxes hold one character, so a digit can only be replaced when it is
    // selected. Focus alone is not enough: a click drops the selection again
    // once the caret lands, hence the same handler on both events.
    (event.target as HTMLInputElement).select();
  }

  // Without this the differ matches the boxes by their (repeated, often empty)
  // values and reorders the inputs whenever a digit changes.
  trackByIndex(index: number) {
    return index;
  }

  onOtpPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData && event.clipboardData.getData('text');
    if (!pasted) {
      return;
    }
    event.preventDefault();
    const digits = pasted.replace(/\D/g, '');
    if (!digits) {
      return;
    }
    this.writeOTPDigits(0, digits);
    this.focusOTPBox(Math.min(digits.length, this.OTP_LENGTH - 1));
  }

  private clearOTP() {
    this.otpDigits = new Array(this.OTP_LENGTH).fill('');
    this.otpValue = '';
    // The boxes only exist once *ngIf="otp" has rendered them.
    setTimeout(() => {
      this.renderOTPBoxes();
      this.focusOTPBox(0);
    });
  }

  private writeOTPDigits(from: number, digits: string) {
    for (let i = 0; i < digits.length && from + i < this.OTP_LENGTH; i++) {
      this.otpDigits[from + i] = digits[i];
    }
    this.syncOTP();
  }

  private syncOTP() {
    this.otpValue = this.otpDigits.join('');
    this.renderOTPBoxes();
  }

  private renderOTPBoxes() {
    if (!this.otpBoxes) {
      return;
    }
    this.otpBoxes.forEach((box, i) => {
      if (box.nativeElement.value !== this.otpDigits[i]) {
        box.nativeElement.value = this.otpDigits[i];
      }
    });
  }

  private focusOTPBox(index: number) {
    if (!this.otpBoxes || index < 0 || index >= this.OTP_LENGTH) {
      return;
    }
    const box = this.otpBoxes.toArray()[index];
    if (box) {
      box.nativeElement.focus();
      box.nativeElement.select();
    }
  }

  /* --- connecting-dots background ------------------------------------------
   * Drifting red dots on white, linked by a line whose opacity falls off with
   * distance, plus a stronger link to the cursor.
   */

  ngAfterViewInit() {
    // The canvas lives inside *ngIf="!token || changePass", so it may not exist.
    const canvas = this.bgCanvas && this.bgCanvas.nativeElement;
    if (!canvas || !canvas.getContext) {
      return;
    }
    this.ctx = canvas.getContext('2d');
    if (!this.ctx) {
      return;
    }

    this.resizeCanvas();
    window.addEventListener('resize', this.onResize);
    canvas.addEventListener('pointermove', this.onPointerMove);
    canvas.addEventListener('pointerleave', this.onPointerLeave);

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.drawFrame();
      return;
    }
    // ~60 repaints a second must not each trigger change detection.
    this.zone.runOutsideAngular(() => this.tick());
  }

  ngOnDestroy() {
    cancelAnimationFrame(this.frameId);
    window.removeEventListener('resize', this.onResize);
    const canvas = this.bgCanvas && this.bgCanvas.nativeElement;
    if (canvas) {
      canvas.removeEventListener('pointermove', this.onPointerMove);
      canvas.removeEventListener('pointerleave', this.onPointerLeave);
    }
    // Pre-existing: the OTP resend countdown otherwise keeps ticking after leaving.
    if (this.resendInterval) {
      clearInterval(this.resendInterval);
      this.resendInterval = null;
    }
  }

  private onResize = () => this.resizeCanvas();

  private onPointerLeave = () => { this.pointer.active = false; };

  private onPointerMove = (event: PointerEvent) => {
    const rect = this.bgCanvas.nativeElement.getBoundingClientRect();
    this.pointer.x = event.clientX - rect.left;
    this.pointer.y = event.clientY - rect.top;
    this.pointer.active = true;
  }

  private resizeCanvas() {
    const canvas = this.bgCanvas.nativeElement;
    const dpr = window.devicePixelRatio || 1;
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    // Back the canvas at device resolution so the dots are not soft on HiDPI.
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    this.seedDots(width, height);
  }

  private seedDots(width: number, height: number) {
    // Density-based count, so a wide monitor is not sparse nor a phone crowded.
    const count = Math.min(150, Math.max(35, Math.round((width * height) / 14000)));
    const dots = [];
    for (let i = 0; i < count; i++) {
      dots.push({
        x: Math.random() * width,
        y: Math.random() * height,
        vx: (Math.random() - 0.5) * this.BASE_DRIFT * this.SPEED,
        vy: (Math.random() - 0.5) * this.BASE_DRIFT * this.SPEED,
        r: this.DOT_RADIUS
      });
    }
    this.dots = dots;
  }

  private tick = () => {
    const canvas = this.bgCanvas.nativeElement;
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;

    for (const d of this.dots) {
      d.x += d.vx;
      d.y += d.vy;
      if (d.x <= 0 || d.x >= width) {
        d.vx = -d.vx;
        d.x = Math.min(Math.max(d.x, 0), width);
      }
      if (d.y <= 0 || d.y >= height) {
        d.vy = -d.vy;
        d.y = Math.min(Math.max(d.y, 0), height);
      }
    }

    this.drawFrame();
    this.frameId = requestAnimationFrame(this.tick);
  }

  private drawFrame() {
    const ctx = this.ctx;
    const canvas = this.bgCanvas.nativeElement;
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    const max = this.LINK_DISTANCE;
    const reach = max * 1.4;

    ctx.clearRect(0, 0, width, height);
    ctx.lineWidth = this.LINE_WIDTH;

    for (let i = 0; i < this.dots.length; i++) {
      const a = this.dots[i];

      for (let j = i + 1; j < this.dots.length; j++) {
        const b = this.dots[j];
        const dist = Math.hypot(a.x - b.x, a.y - b.y);
        if (dist > max) {
          continue;
        }
        ctx.strokeStyle = `rgba(${this.RGB}, ${(1 - dist / max) * 0.3})`;
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(b.x, b.y);
        ctx.stroke();
      }

      if (this.pointer.active) {
        const dist = Math.hypot(a.x - this.pointer.x, a.y - this.pointer.y);
        if (dist < reach) {
          ctx.strokeStyle = `rgba(${this.RGB}, ${(1 - dist / reach) * 0.5})`;
          ctx.beginPath();
          ctx.moveTo(a.x, a.y);
          ctx.lineTo(this.pointer.x, this.pointer.y);
          ctx.stroke();
        }
      }

      ctx.fillStyle = `rgba(${this.RGB}, 0.7)`;
      ctx.beginPath();
      ctx.arc(a.x, a.y, a.r, 0, Math.PI * 2);
      ctx.fill();
    }
  }

}
